import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Promotion() { 
  useEffect(() => {
    document.title = 'Promotion Criteria -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Rules</li>
                <li>Promotion Criteria</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Promotion Criteria</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12"> 
               <ul className="mainlist">
               <li> Students below class VIII are expected to pass in all the subject and obtain minimum 40% of marks in each paper to be eligible to qualify for promotion. </li>
               <li>Students of classes IX and X (ICSE) and XI and XII (ISC) must appear and pass in all subjects offered and obtain 35% marks in each subject to be eligible for promotion from class IX to X (ICSE) and from class XI to XII (ISC). They shall also maintain 75% attendance every year to be eligible to appear in the ICSE and ISC examinations.</li>
               <li>Full Attendance is mandatory for the students of classes IX, X, XI &amp; XII. in case of their absence from school a leave application written and duly signed by the parent must be submitted the following day to the class teacher. In case of sickness, a medical certificate from a certified doctor has to be submitted the day they attend the school. In any case the total attendance should not go below 75% as prescribed by the council.</li>
               <li>There is no provision for conducting retests or re-examination for students who remain absent for any test/ examination. </li>
               <li> If a student is absent for an examination due to sickness, a medical certificate should be sent to the Principal with an application from the parents. Promotion in such cases will depend on his/her performance in all the other tests and examinations. </li>
               <li> Should a child fail to qualify for promotion in a class at the end of two consecutive years, such a student will have to be withdrawn
from the school.</li>
               <li>Disciplinary action will be initiated against any child who is found to have used unfair means in the periodic tests/ examinations
and should the child concerned, continue to repeat the offence, he or she will have to be withdrawn from the school.</li>
             <li>Any student because of detention in a class attains an age which is two or more years above the average age of the class, will have to be withdrawn.</li>
             <li>The assessments made by the teachers and the Principal are fair and final. No representation with regard to promotion will be entertained.</li>
             <li>Parents are kept informed of the academic attainment of their children through their Progress Report which are given periodically at the end of each period of assessment. The final report at the end of the academic year indicates the average grade obtained by the student in each subject in the course of the year. Parents are requested to attend parent teacher meetings on scheduled days and be briefed about the progress of their wards.</li>
         </ul>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Promotion;
